import { imgUrl } from '../../commonInfra/utils/ImgUrl';
import {
  classes,
  cssClass,
  flexRowStyle,
} from '../../style';
import { FlowOutputStepRunStatus } from '../models/FlowOutputStepRunInfo';
import { RunFlowTaskStatus } from '../models/RunFlowTaskInfo';
import { ConnectionCategory } from '../utils/FlowDataConnectionUtils';
const cssPrefix = 'FlowIcon';

export const iconClass = cssClass(cssPrefix, 'icon', {
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
});
export const iconClassWithColor = cssClass(cssPrefix, 'iconWithColor', flexRowStyle, {
  flex: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  backgroundColor: '#2A5775', // temporary, until we have step colors
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
});
const getIconToggleExpandUp = () => cssClass(cssPrefix, 'dropdownUp', {
  backgroundImage: imgUrl('expand_close.png')
});
const getIconToggleExpandDown = () => cssClass(cssPrefix, 'dropdownDown', {
  backgroundImage: imgUrl('expand_open.png')
});
const getIconInputExternalClass = () => cssClass(cssPrefix, 'icon_input_external', {
  backgroundImage: imgUrl('Loom_Flow_Step_Input_DS.svg'),
  borderRadius: 20,
});
const getIconInputFileClass = () => cssClass(cssPrefix, 'icon_input_file', {
  backgroundImage: imgUrl('Loom_Flow_Step_Input_File.svg'),
  borderRadius: 20,
});
const getIconOutputPublishClass = () => cssClass(cssPrefix, 'icon_output_publish', {
  backgroundImage: imgUrl('Loom_Flow_Step_Output_Published_DS.svg')
});
const getIconOutputPublishDataRoleClass = () => cssClass(cssPrefix, 'icon_output_publish', {
  backgroundImage: imgUrl('Loom_Flow_Step_Output_Published_DR.svg')
});
const getIconOutputFileClass = () => cssClass(cssPrefix, 'icon_output_file', {
  backgroundImage: imgUrl('Loom_Flow_Step_Output_File_Extract.svg')
});

const getIconOutputDatabaseClass = () => cssClass(cssPrefix, 'icon_output_database', {
  backgroundImage: imgUrl('Loom_Flow_Step_Output_Database.svg')
});

export function getExpandIcon(expanded: boolean) {
  return classes(expanded ? getIconToggleExpandUp : getIconToggleExpandDown, iconClass);
}

// White icons for use with dark backgrounds
export function getStepIconClass(type: 'input' | 'output', connectionCategory: ConnectionCategory, isDataRole: boolean): string {
  switch (type) {
    case 'input':
      switch (connectionCategory) {
        case 'external':
          return getIconInputExternalClass();
        case 'file':
          return getIconInputFileClass();
        case 'tableau':
          return getIconInputExternalClass();
        case 'tableausite':
          return getIconInputExternalClass();
        default:
          return getIconInputExternalClass();
      }
    case 'output':
      switch (connectionCategory) {
        case 'external':
          return getIconOutputDatabaseClass();
        case 'file':
          return getIconOutputFileClass();
        case 'tableau':
          return getIconOutputPublishClass();
        case 'tableausite':
          return isDataRole ? getIconOutputPublishDataRoleClass() : getIconOutputPublishClass();
        default:
          return getIconOutputPublishClass();
      }
    default:
      return '';
  }
}

export function getOutputIconStyle(connectionCategory: ConnectionCategory, isDataRole: boolean): React.CSSProperties {
  switch(connectionCategory) {
    case 'external':
      return { backgroundImage: imgUrl('table_18px-large.svg') };
    case 'file':
      return { backgroundImage: imgUrl('datasource_extract_18px-large.svg') };
    case 'tableau':
      return { backgroundImage: imgUrl('datasource_18px-large.svg') };
    case 'tableausite':
      return { backgroundImage: imgUrl(isDataRole ? 'datasource_role_18px-large.svg' : 'datasource_18px-large.svg') };
    default:
      return { backgroundImage: imgUrl('datasource_18px-large.svg') };
  }
}

export function getFlowOutputStepRunIconClass(status: string): string {
  switch (status) {
    case FlowOutputStepRunStatus.pending:
      return 'tb-prep-flow-overview-history-status-pending-icon';
    case FlowOutputStepRunStatus.inProgress:
      return 'tb-prep-flow-overview-history-status-inprogress-icon';
    case FlowOutputStepRunStatus.success:
      return 'tb-prep-flow-overview-history-status-success-icon';
    case FlowOutputStepRunStatus.failed:
      return 'tb-prep-flow-overview-history-status-failed-icon';
    case FlowOutputStepRunStatus.cancelled:
      return 'tb-prep-flow-overview-history-status-cancelled-icon';
    default:
      return 'tb-prep-flow-overview-history-status-failed-icon';
  }
}

export function getRunFlowTaskStatusIconClass(status: string): string {
  switch (status) {
    case RunFlowTaskStatus.Suspended:
      return 'tb-react-dg-hcol tb-icon-server-alert-list-suspended';
    case RunFlowTaskStatus.InProgress:
      return 'tb-prep-flow-overview-history-status-inprogress-icon';
    case RunFlowTaskStatus.Succeeded:
      return 'tb-prep-flow-overview-history-status-success-icon';
    case RunFlowTaskStatus.Failed:
      return 'tb-prep-flow-overview-history-status-failed-icon';
    case RunFlowTaskStatus.Scheduled:
    default:
      return 'tb-prep-flow-overview-history-status-pending-icon';
  }
}
